import React from "react";
import ReactDOM from "react-dom";
import { AuthProvider } from "./context/auth";
import Login from "./pages/login/login";
import RoutesConfig from "./routes";
import secureLocalStorage from "react-secure-storage";
import ErrorBoundary from "./ui/components/Error";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "./styles/global.css"

const App = () => {
  const token: any = secureLocalStorage.getItem("access_token");

  return (
    <>
      <ErrorBoundary>
        <AuthProvider>
          <div>{token ? <RoutesConfig /> : <Login />}</div>
        </AuthProvider>
      </ErrorBoundary>
      <ToastContainer position="top-right" autoClose={3000}/>
    </>
  );
};

export default App;
